import { Box } from '@mui/material';
import Hero from './Hero';
// import Features from './Features';
import HowItWorks from './HowItWorks';
// import Testimonials from './Testimonials';
import Pricing from './Pricing';
import CallToAction from './CallToAction';

export const Home = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Hero />
      {/* <Features /> */}
      <HowItWorks />
      {/* <Testimonials /> */}
      <Pricing />
      <CallToAction />
    </Box>
  );
};
